import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=aae30ed8&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=aae30ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae30ed8",
  null
  
)

component.options.__file = "src/components/Dashboard.vue"
export default component.exports